export const getSignerList = `
query getSignerList($tenantId: String!, $aziendaId: Int!) {
    getSignerList(tenantId: $tenantId, aziendaId: $aziendaId) {
        id
        itemId
        fiscalCode
        firstName
        lastName
        email
        completeNumber
        enabled
        certificates {
            id
            type
            identificationType
            enabled
            signatureFlowEnabled
            status
        }
    }
}`;